// Build the canonical public URL for an episode. Mirrors the backend
// helper `_public_episode_url()` so internal links match the URLs the
// sitemap and OG endpoints emit. Falls back to the legacy
// `/episodio/{id}` path when the slug pair is missing — keeps things
// safe during the few seconds between an admin publishing an episode
// and the backfill job running.
export function episodePath(ep) {
  if (!ep) return "/";
  const pod = (ep.podcast_slug || "").trim();
  const slug = (ep.slug || "").trim();
  if (pod && slug) return `/episodio/${pod}/${slug}`;
  return `/episodio/${ep.id || ""}`;
}
